import { SearchModes } from '../../constants';

const checkDoHaveMapMarkers = (store) => {
  const tripSearchResult = store.tripSearch.searchResult;
  if (store.tripSearch.selectedSearchMode === SearchModes.HOTEL) {
    return tripSearchResult && tripSearchResult.hotelPins && tripSearchResult.hotelPins.length > 0;
  }
  if (store.tripSearch.selectedSearchMode === SearchModes.TOUR) {
    return tripSearchResult && tripSearchResult.tourPins && tripSearchResult.tourPins.length > 0;
  }
  return tripSearchResult && tripSearchResult.markers && tripSearchResult.markers.length > 0;
};

export default checkDoHaveMapMarkers;
